module.exports = __webpack_public_path__ + "static/media/map4.35b31938.png";